export default __webpack_public_path__ + "static/media/games-hover.ee6e4140.webp";